const VERSION_FILE = 'version.txt';

type GetInfo = (url: string) => Promise<{ getInfo: () => { version: string } }>;

export const GetInfo: GetInfo = async (url: string) => {
  const response = await fetch(`${url}/${VERSION_FILE}?v=${new Date().getTime()}`);

  if(!response.ok)
    throw new Error(response.statusText);

  const version = await response.text();

  return { getInfo: () => ({ version }) };
};
